import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendario-detalle',
  templateUrl: './calendario-detalle.component.html',
  styleUrls: ['./calendario-detalle.component.css']
})
export class CalendarioDetalleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
